// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_users{height:77vh !important;max-height:77vh}`, "",{"version":3,"sources":["webpack://./src/modules/SelfConfig/components/Table/Table.scss"],"names":[],"mappings":"AAAA,aACE,sBAAA,CACA,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
